import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Mail, Phone, MapPin, ArrowRight, CheckCircle, AlertCircle } from 'lucide-react';

const Footer = () => {
    // ZMIANA: Używamy teraz jednej, spójnej struktury menu
    const menuItems = [
        {
          title: 'Szynkowski Consulting',
          submenu: [
            { name: 'Pozyskiwanie dofinansowań', path: '/pozyskiwanie-dofinansowan' },
            { name: 'Rozliczanie dofinansowań', path: '/rozliczanie-dofinansowan' },
            { name: 'Pożyczki unijne', path: '/pozyczki-unijne' },
            { name: 'Doradztwo strategiczne', path: '/doradztwo-strategiczne' },
            { name: 'Biznes plany i analizy finansowe', path: '/biznes-plany' }
          ]
        },
        {
          title: 'Szynkowski Legal',
          submenu: [
            { name: 'Obsługa prawna biznesu', path: '/obsluga-prawna-biznesu' },
            { name: 'Nowe technologie i innowacje', path: '/nowe-technologie' },
            { name: 'Podatki i finansowanie przedsiębiorstw', path: '/podatki-finansowanie' },
            { name: 'Prawo spółek i M&A', path: '/prawo-spolek' },
            { name: 'Rozwiązywanie sporów', path: '/rozwiazywanie-sporow' },
          ]
        }
    ];

    const consultingMenu = menuItems.find(item => item.title === 'Szynkowski Consulting');
    const legalMenu = menuItems.find(item => item.title === 'Szynkowski Legal');
    
    const legalDocsLinks = [
        { name: 'Polityka prywatności', href: '/polityka-prywatnosci' },
    ];

    // Logika newslettera pozostaje bez zmian
    const [email, setEmail] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [status, setStatus] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();

    const handleSubscribe = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setStatus(null);
        setErrorMessage('');
        try {
            const response = await fetch('https://n8n.agencjasmart.marketing/webhook/szynkowski-newsletter', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: email, source: 'strona-szynkowski-footer', timestamp: new Date().toISOString() })
            });
            if (!response.ok) throw new Error('Błąd podczas zapisu.');
            navigate('/subskrypcja-potwierdzona');
        } catch (error) {
            setStatus('error');
            setErrorMessage(error.message || 'Spróbuj ponownie.');
            setTimeout(() => {
                setStatus(null);
                setErrorMessage('');
            }, 5000);
        } finally {
            setIsSubmitting(false);
        }
    };

  return (
    <footer className="relative bg-black border-t border-white/10 overflow-hidden">
      <div className="absolute inset-0 pointer-events-none opacity-5">
        <div className="absolute bottom-10 left-10 animate-float">
          <Mail className="w-20 h-20 text-violet-600" />
        </div>
        <div className="absolute top-10 right-10 animate-float animation-delay-2000">
          <Phone className="w-24 h-24 text-violet-500" />
        </div>
      </div>
      
      <div className="relative z-10 pt-14 md:pt-20 pb-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8 lg:gap-12 mb-10 md:mb-12 text-center md:text-left">
            
            <div className="sm:col-span-2 md:col-span-4 lg:col-span-1 flex flex-col items-center md:items-start">
              <Link to="/" aria-label="Strona główna">
                <img 
                  src="/logo.png" 
                  alt="Szynkowski & Company" 
                  className="h-12 w-auto mb-4 opacity-90 object-contain"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "https://szynkowski.com.pl/wp-content/uploads/2025/06/Szynkowski-new.png";
                  }}
                />
              </Link>
              <p className="text-gray-400 text-sm">Eksperci w pozyskiwaniu dotacji i obsłudze prawnej firm.</p>
            </div>
            
            {/* ZMIANA: Linki generowane dynamicznie */}
            <div>
              <h4 className="font-semibold mb-4 text-lg text-white">{consultingMenu.title}</h4>
              <ul className="space-y-3">
                {consultingMenu.submenu.map(link => (
                  <li key={link.name}>
                    <Link to={link.path} className="text-gray-400 hover:text-violet-500 transition-colors text-sm">{link.name}</Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* ZMIANA: Linki generowane dynamicznie */}
            <div>
              <h4 className="font-semibold mb-4 text-lg text-white">{legalMenu.title}</h4>
              <ul className="space-y-3">
                {legalMenu.submenu.map(link => (
                  <li key={link.name}>
                    <Link to={link.path} className="text-gray-400 hover:text-violet-500 transition-colors text-sm">{link.name}</Link>
                  </li>
                ))}
              </ul>
            </div>
            
            <div>
              <h4 className="font-semibold mb-4 text-lg text-white">Kontakt</h4>
              <ul className="space-y-4 text-gray-400 text-sm">
                <li className="flex items-start justify-center md:justify-start gap-3">
                  <MapPin size={18} className="mt-0.5 flex-shrink-0 text-violet-600" />
                  <span>Jaśminowa 32A<br />05-092 Łomianki</span>
                </li>
                <li className="flex items-center justify-center md:justify-start gap-3">
                  <Phone size={18} className="text-violet-600" />
                  <a href="tel:+48791335232" className="hover:text-white transition-colors">791 335 232</a>
                </li>
                <li className="flex items-center justify-center md:justify-start gap-3">
                  <Mail size={18} className="text-violet-600" />
                  <a href="mailto:biuro@szynkowski.com.pl" className="hover:text-white transition-colors">biuro@szynkowski.com.pl</a>
                </li>
              </ul>
            </div>
            
            <div>
              <h4 className="font-semibold mb-4 text-lg text-white">Newsletter</h4>
              <p className="text-gray-400 mb-4 text-sm">Bądź na bieżąco z nowymi dotacjami.</p>
              <form onSubmit={handleSubscribe} className="flex flex-col gap-2">
                <div className="flex flex-col sm:flex-row gap-2">
                  <input type="email" placeholder="Twój email" required value={email} onChange={(e) => setEmail(e.target.value)} disabled={isSubmitting} className="flex-1 px-4 py-2 bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg text-white placeholder-gray-500 text-sm focus:outline-none focus:border-violet-500 transition-colors disabled:opacity-50"/>
                  <button type="submit" disabled={isSubmitting} className="bg-gradient-to-r from-violet-600 to-violet-700 text-white p-3 rounded-lg font-semibold hover:shadow-lg hover:shadow-violet-600/25 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center w-[44px] h-[44px]">
                    {isSubmitting ? <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin"></div> : <ArrowRight className="w-5 h-5" />}
                  </button>
                </div>
                <div className="h-6 mt-1 text-xs text-left">
                  {status === 'error' && (
                    <div className="flex items-center gap-2 text-red-400">
                      <AlertCircle className="w-4 h-4 flex-shrink-0" />
                      <span>{errorMessage}</span>
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>
          
          <div className="relative">
            <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent"></div>
            <div className="pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-center md:text-left">
              <p className="text-gray-500 text-sm">© {new Date().getFullYear()} Szynkowski & Company. Wszelkie prawa zastrzeżone. Projekt i realizacja: <a href="https://agencjasmart.marketing" target="_blank" rel="noopener noreferrer" className="hover:text-violet-500 transition-colors">Smart Marketing</a></p>
              <div className="flex gap-6 text-sm">
                {legalDocsLinks.map(link => (
                  <Link key={link.name} to={link.href} className="text-gray-500 hover:text-violet-500 transition-colors">{link.name}</Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
